import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cssClassPrefix, FW_PREFIX } from '../../../shared/constants/generalConstants.js';

/**
 * Copyright 2020, IntraLinks, Inc, All rights reserved.
 */
var BASE_CSS = "".concat(cssClassPrefix, "-footer");
var FW_CSS = "".concat(FW_PREFIX, "-footer");
var IlFooter = function IlFooter(props) {
  var _props$logo = props.logo,
    _props$logo2 = _props$logo === void 0 ? {
      src: '',
      alt: ''
    } : _props$logo,
    src = _props$logo2.src,
    _props$logo2$alt = _props$logo2.alt,
    alt = _props$logo2$alt === void 0 ? '' : _props$logo2$alt,
    _props$copyright = props.copyright,
    copyright = _props$copyright === void 0 ? 'Intralinks Inc.' : _props$copyright,
    children = props.children;
  var year = '2025'; // Hardcoded on purpose

  return /*#__PURE__*/React__default.createElement("footer", {
    className: classNames(BASE_CSS, FW_CSS)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CSS, "__copyright")
  }, src && /*#__PURE__*/React__default.createElement("img", {
    src: src,
    alt: alt
  }), /*#__PURE__*/React__default.createElement("span", null, "\xA9 ".concat(year, ", ").concat(copyright))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(BASE_CSS, "__items")
  }, /*#__PURE__*/React__default.createElement("ul", null, children)));
};
IlFooter.propTypes = {
  logo: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  copyright: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { IlFooter as default };
